import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueWarningHeader: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-header',
		defaultMessage: 'Warning',
		description: 'Heading for warning on the version picker that pertains to the selected issue.',
	},
	issueWarning: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning',
		defaultMessage: 'This issue has {warning}',
		description:
			'Message on version picker that explains which single warning exists on the selected issue.',
	},
	issueMultipleWarnings: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings',
		defaultMessage: 'This issue is done but has:',
		description:
			'Message on version picker that explains which warnings exist on the selected issue.',
	},
	openPullRequest: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.open-pull-request',
		defaultMessage: 'open pull requests',
		description:
			'Warning List item for when the selected issue is closed but has open pull requests.',
	},
	failingBuilds: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.failing-builds',
		defaultMessage: 'failing builds',
		description: 'Warning List item for when the selected issue is closed but has failing builds.',
	},
	unreviewedCode: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.unreviewed-code',
		defaultMessage: 'unreviewed code',
		description: 'Warning List item for when the selected issue is closed but has unreviewed code.',
	},
	openReviews: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.open-reviews',
		defaultMessage: 'open reviews',
		description: 'Warning List item for when the selected issue is closed but has open reviews.',
	},
	issueWarningIssueTerminologyRefreshM4: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-issue-terminology-refresh-m4',
		defaultMessage: 'This work item has {warning}',
		description:
			'Message on version picker that explains which single warning exists on the selected issue.',
	},
	issueMultipleWarningsIssueTerminologyRefreshM4: {
		id: 'software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings-issue-terminology-refresh-m4',
		defaultMessage: 'This work item is done but has:',
		description:
			'Message on version picker that explains which warnings exist on the selected issue.',
	},
});
